/**
 * Wishlist – Heart icon toggle, header badge, wishlist page rendering.
 * Uses MtsStorage with key 'mts-wishlist'.
 */
(function () {
  'use strict';

  var KEY = 'mts-wishlist';
  var SECTION_ID = 'recently-viewed-card'; // Reuse the minimal card section

  function getProductData(btn) {
    var d = btn.dataset;
    return {
      handle: d.wishlistHandle,
      title: d.wishlistTitle,
      url: d.wishlistUrl,
      image: d.wishlistImage,
      price: d.wishlistPrice,
      addedAt: Date.now()
    };
  }

  function syncButtons() {
    if (!window.MtsStorage) return;
    document.querySelectorAll('.mts-wishlist-btn').forEach(function (btn) {
      var handle = btn.dataset.wishlistHandle;
      var active = window.MtsStorage.hasItem(KEY, handle);
      btn.setAttribute('aria-pressed', String(active));
      btn.classList.toggle('is-active', active);
    });
  }

  function updateBadge() {
    if (!window.MtsStorage) return;
    var count = window.MtsStorage.getCount(KEY);
    var badge = document.getElementById('wishlist-count');
    if (badge) {
      badge.textContent = count > 0 ? count : '';
      badge.dataset.count = count;
    }
  }

  function onWishlistClick(e) {
    var btn = e.target.closest('.mts-wishlist-btn');
    if (!btn || !window.MtsStorage) return;
    e.preventDefault();

    var data = getProductData(btn);
    window.MtsStorage.toggleItem(KEY, data);
    syncButtons();
    updateBadge();
  }

  // --- Wishlist page rendering ---
  function renderWishlistPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container || !window.MtsStorage) return;

    var items = window.MtsStorage.getItems(KEY);
    var grid = container.querySelector('.wishlist-page__grid');
    var emptyState = container.querySelector('.wishlist-page__empty');

    if (items.length === 0) {
      if (grid) grid.style.display = 'none';
      if (emptyState) emptyState.style.display = '';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    if (!grid) return;

    var fetches = items.map(function (item) {
      return fetch('/products/' + item.handle + '?section_id=' + SECTION_ID)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    });

    Promise.all(fetches).then(function (htmlArray) {
      var fragment = document.createDocumentFragment();
      htmlArray.forEach(function (html, i) {
        if (!html) return;
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.innerHTML = html;
        fragment.appendChild(li);
      });
      grid.innerHTML = '';
      grid.appendChild(fragment);
    });
  }

  // --- Init ---
  function init() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.mts-wishlist-btn')) {
        onWishlistClick(e);
      }
    });

    document.addEventListener('mts:storage-changed', function (e) {
      if (e.detail && e.detail.key === KEY) {
        syncButtons();
        updateBadge();
      }
    });

    syncButtons();
    updateBadge();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
